import { AuthenticationManager } from "@core/managers/authentication.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { JavascriptHelpers } from "@core/helpers";
import { Logger } from "@core/helpers/logger.helpers";
import { getActivePinia } from "pinia";
import { TEMPORARY_TOKEN_URL_PARAMETER } from "@core/constants";

export class StartupManager {
  /**
   * Logout user if any then proceed to login with provided temporary token
   * then navigate away
   * @param {String} temporaryToken
   * @returns {Promise}
   */
  static async authenticateFromTemporaryToken({ temporaryToken } = {}) {
    try {
      let userHasBeenAutoAuth = false;
      const shouldLogout = await AuthenticationManager.isUserAuthenticated();
      if (shouldLogout) {
        // RG: Automatic Auth - we always logout if user is auth because there's no way to know if the future user is the same as the previous one
        await AuthenticationManager.logout();
        // restart with clean store
        getActivePinia()._s.forEach((store) => store.$reset());
        Logger.info("Automatic Auth - previous user detected and logged out");
      }

      const userIsAutomaticallyAuth = await AuthenticationManager.loginWithTemporaryToken({ temporaryToken });
      if (userIsAutomaticallyAuth) {
        Logger.info("Automatic Auth - temporary token OK, login successful");
        NotificationsManager.success({ message: "SUCCESS.@AUTO_AUTH_SUCCESS" });
        userHasBeenAutoAuth = true;
      }
      return userHasBeenAutoAuth;
    } catch (error) {
      const { status } = error.response || {};
      Logger.info("Automatic Auth - failure on status:", status);
      // if token is invalid
      if (status === 400) {
        NotificationsManager.error({ message: "ERRORS.@AUTO_AUTH_FAIL" });
        // RG: Automatic Auth - we logout on error because we assume the user wanted to log in as someone else
        await AuthenticationManager.logout();
        // restart with clean store
        getActivePinia()._s.forEach((store) => store.$reset());
      }
      throw new Error("Automatic Auth failed", error);
    }
  }

  /**
   * Extract temporary token from an url
   * @param {String} url
   * @example
   * https://api-dev.extracadabra.com?temporary_token=ad454564354fbba2423bb6186aa3f2f881450a442
   * @returns {String}
   */
  static getTemporaryTokenFromUrl({ url }) {
    return JavascriptHelpers.getUrlParameter({ url, parameter: TEMPORARY_TOKEN_URL_PARAMETER });
  }
}
